import { render, staticRenderFns } from "./hiLicense.vue?vue&type=template&id=324af388&"
import script from "./hiLicense.vue?vue&type=script&lang=js&"
export * from "./hiLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports